import {
  LogisticsCalendarDayDetailDto,
  LogisticsCalendarEventDto,
  LogisticsCreateProposalDto,
  LogisticsManageVacationsProposalsDto,
  LogisticsPeriodDto
} from '@app/data/dtos/manage-vacations/logistics/logistics-manage-vacations.dto';
import { SeasonCalendarPeriodDto } from '@app/data/dtos/manage-vacations/manage-vacations.dto';
import {
  LogisticsCalendarEvent,
  LogisticsProposal,
  LogisticsVacationsProposal
} from '@app/entities/models/manage-vacations/logistics-manage-vacations.model';
import { SeasonCalendarDay } from '@app/entities/models/manage-vacations/manage-vacations.model';

import { MapFromFn } from '@mercadona/common/public';
import { Builder } from '@mercadona/common/utils';

export const mapLogisticsVacationsProposals: MapFromFn<
  LogisticsManageVacationsProposalsDto,
  LogisticsVacationsProposal
> = (value) =>
  Builder.forModel(LogisticsVacationsProposal)
    .holidays(value ? value.holidays.map(mapLogisticPeriods) : [])
    .freeDueToPublicHolidays(value ? value.free_due_to_public_holidays.map(mapLogisticPeriods) : [])
    .titleMessage(value ? value.vacation_proposal_message : '')
    .observations(value ? value.observations : '')
    .isDraft(value ? value.is_draft : false)
    .maxDays(value?.entitlement ? value.entitlement.max : 0)
    .build();

export const mapLogisticPeriods: MapFromFn<LogisticsPeriodDto, LogisticsProposal> = (value) =>
  Builder.forModel(LogisticsProposal)
    .startDate(value.start_date)
    .endDate(value.end_date)
    .events(value.events)
    .countableDays(value.countable_days)
    .build();

export const mapLogisticsProposalDto: MapFromFn<LogisticsProposal, SeasonCalendarPeriodDto> = (value) =>
  Builder.forDto<SeasonCalendarPeriodDto>().start_date(value.startDate).end_date(value.endDate).build();

export const mapLogisticsFreeByHolidaysDto: MapFromFn<SeasonCalendarDay, SeasonCalendarPeriodDto> = (value) =>
  Builder.forDto<SeasonCalendarPeriodDto>()
    .start_date(value.date ?? '')
    .end_date(value.date ?? '')
    .build();

export const mapLogisticsCreateProposalDto = (holidays: LogisticsProposal[], freeByHolidays: LogisticsProposal[]) => {
  const createProposal: LogisticsCreateProposalDto = {
    holidays: holidays.map(mapLogisticsProposalDto),
    free_due_to_public_holidays: freeByHolidays.map(mapLogisticsProposalDto) || []
  };

  return createProposal;
};

export const mapLogisticsCalendarEvent: MapFromFn<LogisticsCalendarEventDto, LogisticsCalendarEvent> = (value) =>
  Builder.forModel(LogisticsCalendarEvent)
    .shape(value.shape)
    .position(value.position)
    .name(value.name)
    .description(value.description)
    .people(value.people)
    .build();

export const mapLogisticsCalendarEvents: MapFromFn<LogisticsCalendarDayDetailDto, LogisticsCalendarEventDto[]> = (
  value
) => (value.events ? value.events.map(mapLogisticsCalendarEvent) : []);
